<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetReportList' }">预算执行报告</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <!-- <el-button size="small" plain @click="copy">复制</el-button> -->
                    <el-button size="small" plain @click="editDetails">编辑</el-button>
                    <el-button size="small" plain @click="submit">提交</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="单据编号：">
                                    <el-input v-model="list.mk_report_id" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="审批状态：">
                                    <el-input
                                        v-model="list.approval_status_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="报销事由：">
                                    <el-input v-model="list.name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="完成状态：">
                                    <el-input v-model="list.status_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="报销人姓名：">
                                    <div class="read_only read_only_link">
                                        <span @click="principalClick(list.reim_person_rid)">{{ list.reim_person_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="单据类型：">
                                    <el-input
                                        v-model="list.mk_report_type"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="承担人姓名：">
                                    <div class="read_only read_only_link">
                                        <span @click="principalClick(list.cover_person_rid)">{{ list.cover_person_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="单报销人类型：">
                                    <el-input
                                        v-model="list.mk_single_reim_user_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="支付金额：">
                                    <el-input v-model="list.amount" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="发票金额：">
                                    <el-input
                                        v-model="list.invoice_amount"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="税金：">
                                    <el-input v-model="list.tax_amount" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="付款账号编码：">
                                    <el-input
                                        v-model="list.payment_account_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="类型：">
                                    <el-input v-model="list.type_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="供应商名称：">
                                    <div class="read_only read_only_link">
                                        <span @click="accountClick(list.supplier_rid)">{{ list.supplier_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="备注：">
                                    <el-input v-model="list.remark" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="完成时间：">
                                    <el-input
                                        v-model="list.completion_date"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="业务实体名称：">
                                    <div class="read_only read_only_link">
                                        <span @click="accountClick(list.entity_rid)">{{ list.entity_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="业务实体编码：">
                                    <el-input
                                        v-model="list.mk_subsidiary_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="entity_rid：">
                                    <el-input v-model="list.entity_rid" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="报销人工号：">
                                    <el-input
                                        v-model="list.mk_reim_user_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="reim_person_rid：">
                                    <el-input
                                        v-model="list.reim_person_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="承担人工号：">
                                    <el-input
                                        v-model="list.mk_cover_user_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="cover_person_rid：">
                                    <el-input
                                        v-model="list.cover_person_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="供应商编号：">
                                    <el-input
                                        v-model="list.supplier_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }} </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12"
                                ><el-form-item label="最终审批人：" prop="decision_operator_name">
                                    <div class="read_only">{{ list.decision_operator_name }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"
                                ><el-form-item label="审批意见：" prop="approval_remark">
                                    <div class="read_only">{{ list.approval_remark }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="预算执行行" name="2">
                    <vBudgetExecutionComponent :postList="postList" v-if="flag"></vBudgetExecutionComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="关联预算执行行" name="3">
                    <vBudgetExecutionComponent1 :postList="postList1" v-if="flag1"></vBudgetExecutionComponent1>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vBudgetExecutionComponent from '../../listComponent/budget/budgetExecutionComponent.vue';
import vBudgetExecutionComponent1 from '../../listComponent/budget/budgetExecutionComponent.vue';
export default {
    inject: ['reload'],
    name: 'budgetReportDetails',
    components: {
        vBudgetExecutionComponent,
        vBudgetExecutionComponent1
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                searchBtn: false,
                resetBtn: false,
                addBtn: true,
                setBtn: true,
                period: false,
                params: {
                    budget_execution_report_rid: '',
                    mk_report_type: '',
                    supplier_rid: ''
                }
            },
            flag1: false,
            postList1: {
                headerTitle: false,
                searchBtn: false,
                resetBtn: false,
                addBtn: false,
                setBtn: true,
                period: false,
                params: {
                    relation_mk_report_id: ''
                }
            },
            headerTitle: '预算执行详情',
            list: {},
            activeNames: ['1', '2', '3'],
            rid: ''
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.postList.params.budget_execution_report_rid = to.query.id;
            this.postList.params.mk_report_type = to.query.mk_report_type;
            this.postList.params.supplier_rid = to.query.supplier_rid;
            this.postList1.params.relation_mk_report_id = to.query.mk_report_id;
            this.reload();
        }
    },
    beforeMount() {
        this.rid = this.$route.query.id;
        this.postList.params.budget_execution_report_rid = this.$route.query.id;
        this.postList.params.mk_report_type = this.$route.query.mk_report_type;
        this.postList.params.supplier_rid = this.$route.query.supplier_rid;
        this.postList1.params.relation_mk_report_id = this.$route.query.mk_report_id;
    },
    mounted() {
        this.getDetails(); //获取详情
        this.flag = false;
        this.flag1 = false;
        this.$nextTick(() => {
            this.flag = true;
            this.flag1 = true;
        });
    },
    methods: {
        //报销人 承担人详情
        principalClick(rid) {
            this.$router.push({
                path: 'personDetail',
                query: {
                    id: rid
                }
            });
        },
        //跳转账户详情
        accountClick(rid) {
            this.$router.push({
                path: 'accountDetails',
                query: {
                    id: rid
                }
            });
        },
        // 提交
        submit() {
            this.$confirm('您确定要提交吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['budgetExecutionReportSubmit']({ rid: this.rid })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        },

        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetExecutionReportDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/budgetReportList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //前往编辑页面
        editDetails() {
            this.$router.push({
                path: 'budgetReportEdit',
                query: {
                    type: 1,
                    id: this.rid
                }
            });
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'budgetReportEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'budgetReportEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetReportList' });
            } else {
                this.$router.go(-1);
            }
        },
        //合作方详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetExecutionReportDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.mk_report_id;
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
/deep/.el-collapse-item__wrap {
    border-bottom: none !important;
}
</style>